import React, { useState, useEffect } from 'react';
import { Badge } from './ui/badge';
import { skills } from '../mock';

const Skills = () => {
  const [visibleSkills, setVisibleSkills] = useState([]);

  useEffect(() => {
    const allSkillsFlat = Object.entries(skills).flatMap(([category, items]) =>
      items.map((skill) => ({ category, skill }))
    );

    allSkillsFlat.forEach((item, index) => {
      setTimeout(() => {
        setVisibleSkills((prev) => [...prev, item]);
      }, index * 50);
    });
  }, []);

  return (
    <section className="min-h-screen bg-gradient-to-b from-[#0a0a0a] via-[#0d0d1a] to-[#0a0a0a] py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-5xl md:text-6xl font-bold text-center text-white mb-8">
          Skills & Technologies
        </h2>
        <p className="text-xl text-gray-400 text-center mb-20 max-w-3xl mx-auto">
          A diverse toolkit for building intelligent systems
        </p>

        <div className="space-y-16">
          {Object.entries(skills).map(([category, items]) => (
            <div key={category} className="space-y-6">
              <h3 className="text-2xl font-bold text-blue-400 mb-6 flex items-center gap-3">
                <span className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></span>
                {category}
              </h3>
              <div className="flex flex-wrap gap-4">
                {items.map((skill, index) => {
                  const isVisible = visibleSkills.some(
                    (v) => v.category === category && v.skill === skill
                  );
                  return (
                    <Badge
                      key={index}
                      className={`px-6 py-3 text-lg bg-gradient-to-r from-blue-600/20 to-cyan-600/20 border-blue-500/30 text-blue-200 hover:from-blue-600/40 hover:to-cyan-600/40 hover:scale-110 transition-all duration-300 cursor-default ${
                        isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
                      }`}
                    >
                      {skill}
                    </Badge>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;